/* eslint-disable */
import React from 'react'
import {Checkbox, message} from 'antd'

import {Button, Container, MDBBreadcrumb, MDBBreadcrumbItem, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import jMoment from 'moment-jalaali'
import http from '../../Component/Interceptor/Interseptor'
import moment from 'moment'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../../Component/BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import Loader from '../loaders/loader'
import {productShop} from '../../lib/path'

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})

class EditPreRecord extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      wareName: '',
      manualRegVal: null,
      selectedDate: null,
      selectedOption: null,
      providerValue: '',
      providers: [],
      refFactorVal: moment(),
      typeWarehouseId: '',
      typeDocId: '',
      isInput: '',
      otherSellers: false,
      isInternal: false,
      refWarehouseId: '',
      id: '',
      code: '',
      quantity: '',
      product: [],
      details: [],
      wareHousesname: [],
      docType: [],
      errorDocForm: '',
      addError: '',
      valueBarcode: 'barcodeOnly',
      fadeTable: 'true',
      visible: false,
      searchesProduct: [],
      search: '',
      searchTablevisibility: false,
      pageNumber: 1,
      lengthProducts: 0,
      docNum: '',
      modal: false,
      preRecordInfo: {},
      array: [],
      errorForm: {
        warehouseName: '',
        isInputError: '',
        warehouseTypeError: ''
      },
      docArr: [],
      allDocTypes: [],
      providerId: '',
      modalError: false,
      unMatchProduct: [],
      errorTextModal: 'آیا از ثبت نهایی پیش سند مطمئن هستید؟؟',
      wareText: '',
      docTypeText: '',
      refWareText: '',
      proText: '',
      description: '',
      receiverName: '',
      senderName: '',
      providerName: '',
      refTypeWarehouseName: '',
      manReg: '',
      checked: false,
      registerDate: '',
      registerPerson: '',
      abnormal: false,
      incompatibleRemainProducts: [],
      incompatibleSupplyOrderProducts: [],
      incompatibleDispatchProducts: [],
      confirmCheck: false,
      modalShowUnmatch: false,
      tableNotFound: false,
      tableNotRemain: false,
      typePrimaryWarehouseId: null,
      refTypePrimaryWarehouseId: null,
      preWarehouseDocId: null,
      confirmDate: null,
      refType: '',
      parcelId: ''
    }
  }

  getRefType = (refType) => {
    if (!refType) {
      return ''
    } else {
      if (refType === 'CUSTOMER') return 'مشتری'
      if (refType === 'PROVIDER') return 'فروشنده'
    }
  }

  componentDidMount() {
    // var isInput = document.getElementById('isInput').value;
    //
    //
    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}?export=true`, {}).then((response) => {
    //     let Products = response.data.object.result;
    //
    //     if (response.data.error == null) {
    //
    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });

    let {preWarehouseDocId} = this.props.match.params
    let data = {
      docId: preWarehouseDocId
    }

    const token = sessionStorage.getItem('accessToken')

    // http.get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_WAREHOUSE}`, {
    //
    // }).then((response) => {
    //
    //     if (response.data.error == null) {
    //         this.setState({
    //             wareHousesname: response.data.object
    //         })
    //     } else {
    //         message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
    //     }
    //
    // }).catch((error) => {
    //     console.log(error)
    // });

    this.setState({
      loading: true
    })

    http
      .post(`${WAREHOUSE.WAREHOUSE_DOCUMENT_GET_PREVIEW}`, data, {})
      .then((response) => {
        this.setState({
          preRecordInfo: response.data.object,
          loading: false,
          product: this.sortByKey(response.data.object.detailEntities, 'rowNo'),
          manualReg:
            response.data.object.manualRegisterDate == null ? undefined : response.data.object.manualRegisterDate,
          refFactor: response.data.object.refFactorDate == null ? undefined : response.data.object.refFactorDate,
          isInput: response.data.object.input,
          typeWarehouseId: response.data.object.typeWarehouseId,
          providerId: response.data.object.providerId,
          wareText: response.data.object.typeWarehouseName,
          docTypeText: response.data.object.typeDocName,
          typeDocId: response.data.object.typeDocId,
          refWareText:
            response.data.object.refTypeWarehouseName == null ? '-' : response.data.object.refTypeWarehouseName,
          proText: response.data.object.providerName,
          isInternal: response.data.object.internal,
          refFactorDate: response.data.object.refFactorDate,
          refFactorNo: response.data.object.refFactorNo,

          description: response.data.object.description,
          receiverName: response.data.object.receiverName,
          senderName: response.data.object.senderName,
          providerName: response.data.object.providerName,
          refTypeWarehouseName: response.data.object.refTypeWarehouseName,
          manReg: response.data.object.manualRegisterDate,
          refType: response.data.object.refType,
          checked: response.data.object.internal,
          refWarehouseId: response.data.object.refTypeWarehouseId,
          registerDate: jMoment(response.data.object.registerDate).format('jYY/jMM/jDD'),
          registerPerson: response.data.object.registerPerson,
          abnormal: response.data.object.abnormal,
          typePrimaryWarehouseId: response.data.object.typePrimaryWarehouseId,
          refTypePrimaryWarehouseId: response.data.object.refTypePrimaryWarehouseId,
          preWarehouseDocId: response.data.object.preWarehouseDocId,
          otherSellers: response.data.object.otherSellers,
          confirmDate: response.data.object.confirmDate,
          parcelId: response.data.object.parcelId
        })

        // var typeWare=document.getElementById('wareType');
        // var typeWareText = typeWare.options[typeWare.selectedIndex].text;
        // alert(typeWareText)

        let isInput = this.state.isInput
        var filterWare = this.state.docArr

        // http.get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_DOCUMENT}`, {}).then((response) => {
        //     this.setState({
        //         docType: response.data.object
        //     });
        //
        //     filterWare = [];
        //     this.state.docType.forEach(function (item) {
        //
        //
        //         if (isInput == true) {
        //             if (item.in == true) {
        //                 filterWare.push(item);
        //             }
        //         } else {
        //             if (item.out == true) {
        //                 filterWare.push(item);
        //             }
        //         }
        //
        //
        //     });
        //
        //     this.setState({
        //         docType: filterWare
        //     })
        // }).catch((error) => {
        //     console.log(error)
        // });

        const {product} = this.state

        for (let i = 0; i < product.length; i++) {
          let details = {
            id: product[i]['stockProductId'],
            quantity: Number(product[i]['quantity'])
          }
          let detailsArray = []

          detailsArray.push(details)

          this.setState((prevState) => ({
            details: [...prevState.details, details]
          }))
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
        // alert(JSON.stringify(error))
      })
  }

  submitForm(e) {
    e.preventDefault()
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    })
  }

  confirmCheck(e) {
    const target = e.target
    const value = target.type == 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({
      [name]: value,
      id: value
    })
  }

  linkToInternalWarehouser = () => {
    // typePrimaryWarehouseId: response.data.object.typePrimaryWarehouseId,
    //     refTypePrimaryWarehouseId: response.data.object.refTypePrimaryWarehouseId,
    //     preWarehouseDocId: response.data.object.preWarehouseDocId
    if (this.state.typePrimaryWarehouseId === 4 && this.state.refTypePrimaryWarehouseId === 6) {
      return true
    } else {
      return false
    }
  }

  handleCancel = (e) => {
    console.log(e)
    this.setState({
      visible: false,
      searchTablevisibility: false,
      searchesProduct: []
    })

    this.setState({
      modal: !this.state.modal
    })
  }

  epochTo = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch
  }

  epochFrom = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch
  }

  confirm() {
    this.setState({
      modalError: !this.state.modalError
    })
  }

  cancelError() {
    this.setState({
      modalError: false
    })
  }

  cancelErrorFinaly = () => {
    this.setState({
      modalShowUnmatch: false
    })
  }

  toggleCancelFinaly = () => {
    this.cancelErrorFinaly()
  }

  setFinalyRecord() {
    let {preWarehouseDocId} = this.props.match.params
    let data = {
      docId: preWarehouseDocId,
      typeWarehouseId: this.state.typeWarehouseId,
      isInput: this.state.isInput,
      isInternal: this.state.isInternal,
      abnormal: this.state.abnormal,
      typeDocId: this.state.typeDocId,
      details: this.state.details,
      description: this.state.description == '' ? undefined : this.state.description,
      refWarehouseId: this.state.refWarehouseId,
      manualRegisterDate: this.state.manualReg == null ? undefined : this.state.manualReg,
      providerId: this.state.providerId == null || this.state.providerId == '' ? undefined : this.state.providerId,
      receiverId: this.state.receiverId == '' ? undefined : this.state.receiverId,
      senderId: this.state.senderId == '' ? undefined : this.state.senderId,
      senderName: this.state.senderName == '' ? undefined : this.state.senderName,
      receiverName: this.state.receiverName == '' ? undefined : this.state.receiverName,
      refFactorDate: this.state.refFactorDate == null ? undefined : this.state.refFactorDate,
      refFactorNo: this.state.refFactorNo == '' ? undefined : this.state.refFactorNo,
      checkIncompatible: true,
      parcelId: this.state.parcelId
    }
    this.setState({
      loading: true
    })

    http
      .post(`${WAREHOUSE.WAREHOUSE_DOCUEMNT_RECORD_DOCUMENT}`, data, {})
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data.description != null) {
          message.error(response.data.description)
          this.setState({
            modalError: !this.state.modalError
          })
        } else if (response.data.object.unMatch) {
          this.setState({
            unMatchProduct: response.data.object.unMatchProducts,
            modalError: false,
            modalShowUnmatch: !this.state.modalShowUnmatch,
            textUnMatch: 'این اجناس در انبار انتخاب شده وجود ندارد',
            tableNotFound: true,
            tableNotRemain: false
          })
        } else if (response.data.object.incompatible) {
          this.setState({
            incompatibleRemainProducts: response.data.object.incompatibleRemainProducts,
            incompatibleSupplyOrderProducts: response.data.object.incompatibleSupplyOrderProducts,
            incompatibleDispatchProducts: response.data.object.incompatibleDispatchProducts,
            modalError: false,
            modalShowUnmatch: !this.state.modalShowUnmatch,
            textUnMatch: '',
            tableNotFound: false,
            tableNotRemain: true
          })
        } else {
          let successError = 'پیش سند با شماره ' + response.data.object.preDocId + ' ثبت شد.لطفا صبر کنید '
          message.success(successError, 2000)
          this.setState({
            modalError: false
          })

          setInterval(() => {
            window.location.assign('/PreRecord')
          }, 2000)
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }

  confirmFinalyPreRecord() {
    this.setState({
      loading: true
    })
    let {preWarehouseDocId} = this.props.match.params
    let data = {
      docId: preWarehouseDocId,
      typeWarehouseId: this.state.typeWarehouseId,
      isInput: this.state.isInput,
      isInternal: this.state.isInternal,
      abnormal: this.state.abnormal,
      typeDocId: this.state.typeDocId,
      details: this.state.details,
      description: this.state.description == '' ? undefined : this.state.description,
      refWarehouseId: this.state.refWarehouseId,
      manualRegisterDate: this.state.manualReg == null ? undefined : this.state.manualReg,
      providerId: this.state.providerId == null || this.state.providerId == '' ? undefined : this.state.providerId,
      receiverId: this.state.receiverId == '' ? undefined : this.state.receiverId,
      senderId: this.state.senderId == '' ? undefined : this.state.senderId,
      senderName: this.state.senderName == '' ? undefined : this.state.senderName,
      receiverName: this.state.receiverName == '' ? undefined : this.state.receiverName,
      refFactorDate: this.state.refFactorDate == null ? undefined : this.state.refFactorDate,
      refFactorNo: this.state.refFactorNo == '' ? undefined : this.state.refFactorNo,
      checkIncompatible: false,
      parcelId: this.state.parcelId
    }

    http
      .post(`${WAREHOUSE.WAREHOUSE_DOCUEMNT_RECORD_DOCUMENT}`, data, {})
      .then((response) => {
        this.setState({
          loading: false
        })

        if (response.data.description != null) {
          message.error(response.data.description)
          this.setState({
            modalError: !this.state.modalError
          })
        } else if (response.data.object.incompatible) {
          this.setState({
            incompatibleRemainProducts: response.data.object.incompatibleRemainProducts,
            incompatibleSupplyOrderProducts: response.data.object.incompatibleSupplyOrderProducts,
            incompatibleDispatchProducts: response.data.object.incompatibleDispatchProducts,
            modalError: false,
            modalShowUnmatch: true,
            textUnMatch: '',
            tableNotFound: true,
            tableNotRemain: false
          })
        } else {
          let successError = 'پیش سند با شماره ' + response.data.object.preDocId + ' ثبت شد.لطفا صبر کنید '
          message.success(successError, 2000)
          this.setState({
            modalError: false
          })

          setInterval(() => {
            window.location.assign('/PreRecord')
          }, 2000)
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }

  sortByKey = (array, key) => {
    return array.sort(function(a, b) {
      var x = a[key]
      var y = b[key]
      return x < y ? -1 : x > y ? 1 : 0
    })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;margin:1mm !important}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }
    head.appendChild(style)
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  showReadUnmatch = () => {
    let {preWarehouseDocId} = this.props.match.params
    let data = {
      docId: preWarehouseDocId,
      typeWarehouseId: this.state.typeWarehouseId,
      isInput: this.state.isInput,
      isInternal: this.state.isInternal,
      abnormal: this.state.abnormal,
      typeDocId: this.state.typeDocId,
      details: this.state.details,
      description: this.state.description == '' ? undefined : this.state.description,
      refWarehouseId: this.state.refWarehouseId,
      manualRegisterDate: this.state.manualReg == null ? undefined : this.state.manualReg,
      providerId: this.state.providerId == null || this.state.providerId == '' ? undefined : this.state.providerId,
      receiverId: this.state.receiverId == '' ? undefined : this.state.receiverId,
      senderId: this.state.senderId == '' ? undefined : this.state.senderId,
      senderName: this.state.senderName == '' ? undefined : this.state.senderName,
      receiverName: this.state.receiverName == '' ? undefined : this.state.receiverName,
      refFactorDate: this.state.refFactorDate == null ? undefined : this.state.refFactorDate,
      refFactorNo: this.state.refFactorNo == '' ? undefined : this.state.refFactorNo
    }
    this.setState({
      loading: true
    })
    http
      .post(`warehouse/document/check/preview`, data, {})
      .then((res) => {
        this.setState({
          loading: false
        })
        if (res.data.error === null) {
          this.setState({
            incompatibleSupplyOrderProducts: res.data.object.incompatibleSupplyOrderProducts,
            incompatibleDispatchProducts: res.data.object.incompatibleDispatchProducts,
            incompatibleRemainProducts: res.data.object.incompatibleRemainProducts,
            modalShowUnmatchRead: true
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  copyClipBoard = (unmatch, error) => {
    let str = ''
    let title =
      ' ردیف ' +
      ' | ' +
      ' سفارش ' +
      ' | ' +
      '  ورود ' +
      ' | ' +
      '       کد کالا          ' +
      ' | ' +
      ' نام کالا ' +
      '\n'
    let dashe = '----------------------------------------------------------------------------------------' + '\n'
    let concat = title + dashe
    for (let i = 0; i < unmatch.length; i++) {
      let barcodeSpace = unmatch[i].barCode
      if (barcodeSpace.length < 13) {
        barcodeSpace = barcodeSpace.padStart(15)
      }
      str +=
        i +
        1 +
        '         |     ' +
        unmatch[i].remainQuantity +
        '        |    ' +
        unmatch[i].requestedQuantity +
        '     |  ' +
        barcodeSpace +
        '  | ' +
        unmatch[i].title +
        '\n'
      // str += 'تعداد سفارش : ' + unmatch[i].remainQuantity + ' ~ ' + ' تعداد ورود :‌ ' + unmatch[i].requestedQuantity + ' ~ ' + ' بارکد محصول‌ :  ' + unmatch[i].barCode + ' ~ ' + ' کد محصول : ' + unmatch[i].articleId + ' ~ ' + ' نام کالا :‌ ' + unmatch[i].title + '\n'
    }
    if (error === 'show') {
      message.success('در clipboard ذخیره شد')
    }
    return title + dashe + str
  }

  showProductNames = (productName, productGenericTitle) => {
    if (productGenericTitle) {
      if (productGenericTitle.trim() === productName.trim()) {
        return <span className="font-weight-bold">{productName}</span>
      } else {
        return (
          <>
            <p className="font-weight-bold">{productName}</p>
            <p className="mb-0 font-weight-bold text-dark">({productGenericTitle})</p>
          </>
        )
      }
    } else {
      return <span>{productName}</span>
    }
  }

  render() {
    const {wareHousesname, preRecordInfo, product} = this.state
    const style = product.length == '0' ? 'tableProductWarehouse hide' : 'tableProductWarehouse'

    var initialVal = 0
    var sumProduct = this.state.product.reduce(function(acc, current) {
      return Number(acc) + Number(current.quantity)
    }, initialVal)

    return (
      <div className="rtl sanad">
        {!this.state.modalShowUnmatch && !this.state.modalError && <Loader show={this.state.loading} />}

        <div className="printDocWrapp printSection" style={{position: 'relative'}}>
          <div className="headerDocWrapp">
            <div className="headerDoc">
              <figure className="rightPrintInfo" style={{fontSize: '1.1em'}}>
                <p>
                  <span className="boldPrint">شماره پیش سند :</span>
                  <span className="valuePrint">{this.props.match.params.preWarehouseDocId}</span>
                </p>
                <p>
                  <span className="boldPrint">تاریخ ثبت :</span>
                  <span className="valuePrint">{this.state.registerDate}</span>
                </p>
                <p>
                  <span className="boldPrint">تاریخ دستی سند :</span>
                  <span className="valuePrint">
                    {this.state.manualReg == null ? '' : jMoment(this.state.manualReg).format('jYYYY/jMM/jDD')}
                  </span>
                </p>
              </figure>

              <figure className="rightHeaderDoc">
                <img className="printLogoDoc" src={require('../../image/branding/logo-mini.svg')} alt="" />
                <h4>پیش سند {this.state.isInput ? 'وارده' : 'صادره'}</h4>
                <h4>انبار {this.state.wareText}</h4>
                {/*<h4>{this.props.match.params.natureDocNo}</h4>*/}
              </figure>
              <figure className="leftPrintInfo" style={{fontSize: '1.1em'}}>
                <p>کاربر چاپ پیش سند : {cookie.load('name')}</p>
                <p>{'تاریخ چاپ : ' + jMoment().format('jYY/jMM/jDD HH:mm')}</p>
                {/*<p>کاربر ثبت کننده سند : {this.state.recorderPerson}</p>*/}
              </figure>
            </div>
          </div>
          <div className="bodyDocPrint">
            <div className="itemBodyPrintDoc">
              <figure>
                <p>
                  <span className="boldPrint">نام انبار : </span>
                  <span className="valuePrint">{this.state.wareText}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint">بین انبار : </span>
                  <span className="valuePrint">{this.state.checked ? 'هست' : 'نیست'}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> انبار طرف : </span>
                  <span className="valuePrint">{this.state.refTypeWarehouseName}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> ماهیت : </span>
                  <span className="valuePrint">{this.state.isInput ? 'وارده' : 'صادره'}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> نوع طرف : </span>
                  <span className="valuePrint">{this.getRefType(this.state.refType)}</span>
                </p>
              </figure>
              {this.state.refType === 'CUSTOMER' && !this.state.checked && this.state.parcelId && (
                <figure>
                  <p>
                    <span className="boldPrint">شناسه مرسوله ‌:‌ </span>
                    <span className="valuePrint">{this.state.parcelId}</span>
                  </p>
                </figure>
              )}
              <figure>
                <p>
                  <span className="boldPrint"> تحویل دهنده : </span>
                  <span className="valuePrint">{this.state.senderName}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> تاریخ فاکتور طرف : </span>
                  <span className="valuePrint">
                    {this.state.refFactor == null ? '' : jMoment(this.state.refFactor).format('jYYYY/jMM/jDD')}
                  </span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> تامین کننده : </span>
                  <span className="valuePrint">{this.state.providerName}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> نوع سند : </span>
                  <span className="valuePrint">{this.state.docTypeText}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> تحویل گیرنده : </span>
                  <span className="valuePrint">{this.state.receiverName}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> شماره فاکتور : </span>
                  <span className="valuePrint">{this.state.refFactorNo}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> سند اصلاحی : </span>
                  <span className="valuePrint">{this.state.abnormal ? 'هست' : 'نیست'}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> خرید متفرقه : </span>
                  <span className="valuePrint">{this.state.otherSellers ? 'هست' : 'نیست'}</span>
                </p>
              </figure>
            </div>
            <div className="descriptionDoc">
              <p>توضیحات سند : {this.state.description}</p>
            </div>
          </div>
          <table className="printTable printDocTable">
            <thead>
              <tr>
                <td>
                  <div className="page-header-space" />
                </td>
              </tr>
            </thead>

            <tbody>
              <tr className="firstRow">
                <th>ردیف</th>
                <th>تامین کننده</th>
                <th>کد محصول</th>
                <th>بارکد محصول</th>
                <th>نام محصول</th>
                <th>مقدار</th>
                <th>واحد</th>
                <th>تاریخ تولید</th>
              </tr>
              {this.state.product.map((items, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{items.providerName}</td>
                  <td>{items.articleId}</td>
                  <td>{items.productCode}</td>
                  <td>
                    <span target="_blank" className="text-decoration-none">
                      {items.productName}
                    </span>
                  </td>
                  <td>{items.quantity}</td>
                  <td>{items.productUnitTitle}</td>
                  <td>{items.manufactureDate}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={5}>جمع اقلام کالا</td>
                <td>{sumProduct}</td>
                <td colSpan={2} />
              </tr>
              <tr>
                <td className="signatureCell" rowSpan={3} colSpan={8}>
                  <div className="signatureDoc">
                    <figure>
                      <p>امضای تحویل دهنده : </p>
                    </figure>
                    <figure>
                      <p>امضای تحویل گیرنده : </p>
                    </figure>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="noPrint container-fluid">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>انبار</li>
            <li>تایید نهایی پیش سند</li>
          </ul>
          <div className="container-fluid position-relative my-2 p-2 bg-white">
            <div className="card">
              <div className="card-header d-flex flex-row justify-content-between">
                <h5 className="font-weight-bold mb-0">
                  {'شماره پیش سند : ' + this.props.match.params.preWarehouseDocId}
                </h5>
              </div>
              <div className="card-body p-3">
                <div className="row">
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label htmlFor="wareType">انبار</label>
                    <input
                      type="text"
                      disabled={true}
                      tabIndex="5"
                      name="senderName"
                      className="form-control"
                      defaultValue={preRecordInfo.typeWarehouseName}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label htmlFor="ماهیت">ماهیت</label>
                    <select className="form-control" id="isInput" disabled={true} name="isInput" tabIndex="2">
                      <option value={true} selected={preRecordInfo.input ? true : false}>
                        وارده
                      </option>
                      <option value={false} selected={!preRecordInfo.input ? true : false}>
                        صادره
                      </option>
                    </select>
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label htmlFor="ماهیت">نوع طرف</label>
                    <select className="form-control" id="refType" disabled={true} name="refType" tabIndex="2">
                      <option selected={!this.state.refType ? true : false} value={null}>
                        ------
                      </option>
                      <option selected={this.state.refType === 'CUSTOMER' ? true : false} value={'CUSTOMER'}>
                        مشتری
                      </option>
                      <option selected={this.state.refType === 'PROVIDER' ? true : false} value={'PROVIDER'}>
                        فروشنده
                      </option>
                    </select>
                  </div>

                  {this.state.refType === 'CUSTOMER' && !this.state.checked && this.state.parcelId && (
                    <div className="col-12 col-md-4 my-2 col-lg-2">
                      <label>شناسه مرسوله</label>
                      <input
                        type="number"
                        disabled
                        defaultValue={this.state.parcelId}
                        name="parcelId"
                        className="form-control"
                      />
                    </div>
                  )}

                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label htmlFor="docType">نوع سند</label>
                    <input
                      type="text"
                      disabled={true}
                      tabIndex="5"
                      name="typeDocId"
                      className="form-control"
                      defaultValue={preRecordInfo.typeDocName}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2 d-flex flex-column align-content-center justify-content-center">
                    <label className="hiddenLabel">sd</label>
                    <Checkbox
                      className="form-check"
                      disabled={true}
                      name="isInternal"
                      defaultValue={preRecordInfo.internal ? true : false}
                      checked={this.state.checked}
                      tabIndex="4"
                      defaultChecked={preRecordInfo.internal == true ? true : false}
                      id="isInternal"
                    >
                      سند بین انبار
                    </Checkbox>
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2 d-flex flex-column align-content-center justify-content-center">
                    <label className="hiddenLabel">sd</label>
                    <Checkbox name="abnormal" tabIndex="4" checked={this.state.abnormal} disabled={true}>
                      سند اصلاحی
                    </Checkbox>
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2 d-flex flex-column align-content-center justify-content-center">
                    <label className="hiddenLabel">sd</label>
                    <Checkbox name="otherSellers" tabIndex="4" checked={this.state.otherSellers} disabled={true}>
                      خرید متفرقه
                    </Checkbox>
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label>تحویل دهنده</label>
                    <input
                      type="text"
                      disabled={true}
                      tabIndex="5"
                      name="senderName"
                      className="form-control"
                      defaultValue={preRecordInfo.senderName}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label>تحویل گیرنده</label>
                    <input
                      type="text"
                      disabled={true}
                      tabIndex="9"
                      name="receiverName"
                      className="form-control"
                      defaultValue={preRecordInfo.receiverName}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label>تاریخ دستی سند </label>
                    <input
                      value={this.state.manualReg == null ? '' : jMoment(this.state.manualReg).format('jYYYY/jMM/jDD')}
                      className="form-control"
                      disabled={true}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label>تامین کننده</label>
                    <input
                      type="text"
                      disabled={true}
                      tabIndex="5"
                      name="providerName"
                      className="form-control"
                      defaultValue={preRecordInfo.providerName}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label htmlFor="">انبار طرف</label>
                    <input
                      type="text"
                      disabled={true}
                      tabIndex="5"
                      name="refWarehouseId"
                      className="form-control"
                      defaultValue={preRecordInfo.refTypeWarehouseName}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label>شماره فاکتور</label>
                    <input
                      type="text"
                      disabled={true}
                      tabIndex="11"
                      name="refFactorNo"
                      className="form-control"
                      defaultValue={preRecordInfo.refFactorNo}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label>تاریخ فاکتور طرف</label>
                    <input
                      value={this.state.refFactor == null ? '' : jMoment(this.state.refFactor).format('jYYYY/jMM/jDD')}
                      className="form-control"
                      disabled={true}
                    />
                  </div>
                  <div className="col-12 my-2">
                    <lable>توضیحات</lable>

                    <input
                      type="text"
                      className="form-control"
                      style={{height: '40px'}}
                      defaultValue={preRecordInfo.description}
                      id="description"
                      name="description"
                      disabled={true}
                      tabIndex="12"
                    />
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-12">
                    <table className="baseTable">
                      <tbody>
                        <tr className="firstRow">
                          <td>ردیف</td>
                          <td>تامین کننده</td>
                          <td>کد محصول</td>
                          <td>بارکد محصول</td>
                          <td>نام محصول</td>
                          <td>مقدار</td>
                          <td>واحد</td>
                          <td>تاریخ تولید</td>
                        </tr>
                        {this.state.product.map((items, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{items.providerName}</td>
                            <td>{items.articleId}</td>
                            <td>{items.productCode}</td>
                            <td className="text-left">
                              <a
                                target="_blank"
                                className="text-decoration-none text-left"
                                href={productShop({articleId: items.articleId})}
                              >
                                {this.showProductNames(items.productName, items.productGenericTitle)}
                              </a>
                            </td>
                            <td>{items.quantity}</td>
                            <td>{items.productUnitTitle}</td>
                            <td>{items.manufactureDate}</td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan={5}>جمع اقلام کالا</td>
                          <td>{sumProduct}</td>
                          <td colSpan={2} />
                        </tr>
                      </tbody>
                    </table>
                    <div
                      style={{bottom: 10, right: 10}}
                      className="d-flex position-sticky mt-3 flex-row align-content-center align-item-center"
                    >
                      {this.state.confirmDate === null && (
                        <button
                          className={'btn btn-primary btn-sm'}
                          onClick={() =>
                            window.location.assign(`/EditPreRecord/${this.props.match.params.preWarehouseDocId}`)
                          }
                        >
                          ویرایش پیش سند
                        </button>
                      )}
                      {this.state.confirmDate === null && (
                        <>
                          {this.linkToInternalWarehouser() ? (
                            <button
                              className={'btn btn-primary btn-sm'}
                              onClick={() =>
                                window.location.assign(`/addRecord/internal/${this.state.preWarehouseDocId}`)
                              }
                            >
                              تایید سند دپو
                            </button>
                          ) : (
                            <button className={'btn btn-primary btn-sm'} onClick={this.confirm.bind(this)}>
                              تایید پیش سند
                            </button>
                          )}
                        </>
                      )}
                      <button
                        className="btn btn-sm bg-white"
                        onClick={this.exportPrint}
                        style={{color: '#000', fontWeight: 600}}
                      >
                        چاپ
                        <i className="fas fa-print align-middle mx-1" />
                      </button>
                      {this.state.confirmDate === null && (
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={this.showReadUnmatch}
                          style={{color: '#000', fontWeight: 600}}
                        >
                          مغایرت گیری
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={this.state.modalError} toggle={this.cancelError.bind(this)} size="sm">
          <ModalHeader toggle={this.cancelError.bind(this)}>تاییدیه</ModalHeader>
          <ModalBody>
            <Loader show={this.state.loading} />
            <p className="titleSm" />
            <p className="titleSm">
              <Checkbox
                className="form-check"
                name="confirmCheck"
                checked={this.state.confirmCheck}
                onChange={this.confirmCheck.bind(this)}
              >
                {this.state.errorTextModal}
              </Checkbox>
            </p>
          </ModalBody>
          <ModalFooter>
            <button
              className="confirmBtnModal"
              disabled={this.state.confirmCheck ? false : true}
              onClick={this.setFinalyRecord.bind(this)}
            >
              تایید پیش سند
            </button>
            <button className="cancelBtnModal" onClick={this.cancelError.bind(this)}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalShowUnmatch} toggle={this.toggleCancelFinaly.bind(this)}>
          <ModalHeader toggle={this.toggleCancelFinaly.bind(this)}>لیست مغایرت ها</ModalHeader>
          <ModalBody>
            <Loader show={this.state.loading} />
            <p className="titleSm">{this.state.textUnMatch}</p>

            <div
              className="unMatchClass"
              style={this.state.incompatibleRemainProducts.length == '0' ? {display: 'none'} : {display: 'block'}}
            >
              <p>لیست مغایرت موجودی انبار</p>
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام محصول</td>
                    <td>کد محصول</td>
                    <td>تعداد درخواست شده</td>
                    <td>تعداد موجودی</td>
                  </tr>
                  {this.state.incompatibleRemainProducts.map((product, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: product.articleId})}>
                          {product.title}
                        </a>
                      </td>
                      <td>{product.articleId}</td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {product.requestedQuantity}
                      </td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {product.remainQuantity}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div
              className="unMatchClass"
              style={this.state.incompatibleSupplyOrderProducts.length == '0' ? {display: 'none'} : {display: 'block'}}
            >
              <p>لیست مغایرت موجودی سفارش تامین کننده</p>
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام محصول</td>
                    <td>کد محصول</td>
                    <td>تعداد درخواست شده</td>
                    <td>تعداد سفارش</td>
                  </tr>
                  {this.state.incompatibleSupplyOrderProducts.map((product, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: product.articleId})}>
                          {product.title}
                        </a>
                      </td>
                      <td>{product.articleId}</td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {product.requestedQuantity}
                      </td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {product.remainQuantity}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div
              className="unMatchClass"
              style={this.state.incompatibleDispatchProducts.length == '0' ? {display: 'none'} : {display: 'block'}}
            >
              <p>لیست مغایرت کالا های توزیع</p>
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام محصول</td>
                    <td>کد محصول</td>
                    <td>تعداد درخواست شده</td>
                    <td>تعداد توزیع</td>
                  </tr>
                  {this.state.incompatibleDispatchProducts.map((product, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: product.articleId})}>
                          {product.title}
                        </a>
                      </td>
                      <td>{product.articleId}</td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {product.requestedQuantity}
                      </td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {product.remainQuantity}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/*<div style={this.state.tableNotFound?{display:'block'}:{display:'none'}}>*/}
            {/*<table className='baseTable'>*/}
            {/*<tbody>*/}
            {/*<tr className='firstRow'>*/}
            {/*<td>ردیف</td>*/}
            {/*<td>نام محصول</td>*/}
            {/*<td>کد محصول</td>*/}
            {/*<td>بارکد محصول</td>*/}
            {/*</tr>*/}
            {/*{this.state.unMatchProduct.map((product, index) => (*/}
            {/*<tr key={index}>*/}
            {/*<td>{index + 1}</td>*/}
            {/*<td>{product.title}</td>*/}
            {/*<td>{product.articleId}</td>*/}
            {/*<td>{product.barCode}</td>*/}
            {/*</tr>*/}
            {/*))}*/}
            {/*</tbody>*/}
            {/*</table>*/}
            {/*</div>*/}
          </ModalBody>
          <ModalFooter>
            <button
              className="confirmBtnModal"
              style={this.state.tableNotFound ? {display: 'none'} : {display: 'block'}}
              onClick={this.confirmFinalyPreRecord.bind(this)}
            >
              تایید نهایی پیش سند
            </button>
            <button className="cancelBtnModal" onClick={this.cancelErrorFinaly.bind(this)}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalShowUnmatchRead} toggle={() => this.setState({modalShowUnmatchRead: false})}>
          <ModalHeader toggle={this.cancelError.bind(this)}>لیست مغایرت ها</ModalHeader>
          <ModalBody>
            <div
              className="unMatchClass"
              style={this.state.incompatibleRemainProducts.length == '0' ? {display: 'none'} : {display: 'block'}}
            >
              <p>لیست مغایرت موجودی انبار</p>
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام محصول</td>
                    <td>کد محصول</td>
                    <td>{this.state.checkIsInput ? 'تعداد ورود' : 'تعداد در سند'}</td>
                    <td>تعداد موجودی</td>
                  </tr>
                  {this.state.incompatibleRemainProducts.map((product, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: product.articleId})}>
                          {product.title}
                        </a>
                      </td>
                      <td>{product.articleId}</td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {product.requestedQuantity}
                      </td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {product.remainQuantity}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div
              className="unMatchClass"
              style={this.state.incompatibleSupplyOrderProducts.length == '0' ? {display: 'none'} : {display: 'block'}}
            >
              <p>لیست مغایرت موجودی سفارش تامین کننده</p>
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام محصول</td>
                    <td>کد محصول</td>
                    <td>{this.state.checkIsInput ? 'تعداد ورود' : 'تعداد در سند'}</td>
                    <td>تعداد سفارش</td>
                  </tr>
                  {this.state.incompatibleSupplyOrderProducts.map((product, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: product.articleId})}>
                          {product.title}
                        </a>
                      </td>
                      <td>{product.articleId}</td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {product.requestedQuantity}
                      </td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {product.remainQuantity}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <CopyToClipboard
                text={this.copyClipBoard(this.state.incompatibleSupplyOrderProducts, 'notShow')}
                onCopy={() => this.copyClipBoard(this.state.incompatibleSupplyOrderProducts, 'show')}
              >
                <span
                  className="my-4 text-white p-2 d-inline-block rounded"
                  style={{background: '#f7941e', cursor: 'pointer'}}
                >
                  کپی در clipBoard
                </span>
              </CopyToClipboard>
            </div>

            <div
              className="unMatchClass"
              style={this.state.incompatibleDispatchProducts.length == '0' ? {display: 'none'} : {display: 'block'}}
            >
              <p>لیست مغایرت کالا های توزیع</p>
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام محصول</td>
                    <td>کد محصول</td>
                    <td>{this.state.checkIsInput ? 'تعداد ورود' : 'تعداد در سند'}</td>
                    <td>تعداد توزیع</td>
                  </tr>
                  {this.state.incompatibleDispatchProducts.map((product, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: product.articleId})}>
                          {product.title}
                        </a>
                      </td>
                      <td>{product.articleId}</td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {product.requestedQuantity}
                      </td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {product.remainQuantity}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div style={this.state.tableNotFound ? {display: 'block'} : {display: 'none'}}>
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام محصول</td>
                    <td>کد محصول</td>
                    <td>بارکد محصول</td>
                  </tr>
                  {this.state.unMatchProduct.map((product, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: product.articleId})}>
                          {product.title}
                        </a>
                      </td>
                      <td>{product.articleId}</td>
                      <td>{product.barCode}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({modalShowUnmatchRead: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default EditPreRecord
